import './modal.scss'

let service = function (
	$rootScope,
	$filter,
	Http,
	$ionicPopup
) {
	'ngInject'

	var Process = this;
	var startModal, endModal;
	
	this.snapshot = (id) => Http.get('/v1/process/snapshot'+ (id ? '/' + id : ''));
	this.action = (data) => Http.post('/v1/process/action', 'POST', data);
	this.create = (data) => Http.post('/v1/process/create', 'POST', data);
	this.ranking = () => Http.get('/v1/process/ranking');
	
	this.broadcastStep = (step) => {
		$rootScope.$broadcast('STEP_CHANGED', step);
	}

	this.modals = {
		start: function(show) {
			if (show) {
				startModal = $ionicPopup.show({
					title: $filter('ucfirst')($filter('translate')('process_model_start_title')),
					subTitle: $filter('ucfirst')($filter('translate')('process_model_start_content')),
					buttons: []
				});
			} else {
				if (startModal !== undefined) {
					startModal.close();
				}
				
			}
		},
		end: function(show) {
			if (show) {
				endModal = $ionicPopup.show({
					title: $filter('ucfirst')($filter('translate')('process_model_end_title')),
					subTitle: $filter('ucfirst')($filter('translate')('process_model_end_content')),
					buttons: []
				});
			} else {
				if (endModal !== undefined) {
					endModal.close();
				}
			}
		}
	}

}

export default service;


// WEBPACK FOOTER //
// ./app/components/process/process.service.js